import { Alert, Space } from "antd";
import React, { useState, useEffect } from "react";

export function ToastComponent({
  message,
  duration,
  handleToastClose,
  toastType,
}) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
      handleToastClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration]);

  if (!isVisible || !message) return null;

  return (
    <Space
      direction="vertical"
      className="center-text"
      style={{
        position: "fixed",
        zIndex: 2005,
      }}
    >
      <Alert message={message} type={toastType ?? "success"} showIcon />
    </Space>
  );
}
